import { ReactComponent as ArrowsClockwiseIcon } from './arrowsClockwise.svg';

export default ArrowsClockwiseIcon;
